export enum CsvProcessStatus {
  OK = 'OK',
  ERRORS = 'ERRORS',
  FAILED = 'FAILED'
}
